export default __webpack_public_path__ + "static/media/carousel-item-05.291332e2.jpg";